import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {AchooFilterBoxComponent} from '../../../core/achoo-filter-box/achoo-filter-box.component';
import {BlockedReason, InvalidAction, WallType} from '../../../../models/user';
import {
  ActionDetails, ActionSource, EventTrackerService, Page, TargetType,
  UserActionType
} from '../../../services/event-tracker/event-tracker.service';

@Component({
  selector: 'send-to-review',
  templateUrl: './send-to-review.component.html',
  styleUrls: ['./send-to-review.component.scss']
})
export class SendToReviewComponent implements OnInit {
  readonly DO_NOT_SEND_EMAIL_OPTION_ID = -1;
  readonly ALL_OPTION_ID = 0;
  @ViewChild('ReviewerList') reviewerListComp: AchooFilterBoxComponent;
  @Output() changeReviewerEvent: EventEmitter<any> = new EventEmitter();
  reviewerList;
  needToReview = false;
  selectedReviewers = [];
  constructor(private userService: UserService, private translate: TranslateService, private eventTracker: EventTrackerService) { }

  ngOnInit() {
    this.loadReviewerList();
  }

  private loadReviewerList() {
    this.reviewerList = [{
      id: this.DO_NOT_SEND_EMAIL_OPTION_ID,
      name: 'Don\'t send any emails'
    }];
    this.userService.loadReviewerList(this.userService.getCompanyId()).subscribe((res) => {
      if (res && res.length > 0) {
        const reviewerOptionList = [{
          id: this.ALL_OPTION_ID,
          name: 'All'
        }];
        reviewerOptionList.push(...res);
        this.reviewerList = this.reviewerList.concat(reviewerOptionList);
      }
    }, (err) => {
      this.reviewerList = [];
    });
  }

  onChangeReviewer(evt) {
    if (this.selectedReviewers.length === 0) {
      setTimeout(() => {
        this.needToReview = false;
      }, 200);
    } else {
      this.changeReviewerEvent.emit({
        addForReview: this.needToReview,
        selectedReviewers: this.selectedReviewers.indexOf(this.DO_NOT_SEND_EMAIL_OPTION_ID) >= 0 ? [] : this.selectedReviewers,
        needToSendMPEvent: true
      });
    }
  }

  onSelectReviewer(evt) {
    const selectedReviewerIds = evt.map(s => s.id);
    const lastSelectedReviewer = selectedReviewerIds[selectedReviewerIds.length - 1];
    if (lastSelectedReviewer === this.ALL_OPTION_ID) {
      const allUsers = this.reviewerList.filter(r => r.id !== this.ALL_OPTION_ID && r.id !== this.DO_NOT_SEND_EMAIL_OPTION_ID).map(re => re.id);
      const hasSelectedAllUser = allUsers.filter(u => selectedReviewerIds.indexOf(u) < 0).length === 0;
      if (hasSelectedAllUser) {
        this.selectedReviewers = [];
      } else {
        this.selectedReviewers = allUsers;
      }
    } else if (lastSelectedReviewer === this.DO_NOT_SEND_EMAIL_OPTION_ID) {
      this.selectedReviewers = [this.DO_NOT_SEND_EMAIL_OPTION_ID];
    } else {
      const selectedOptions = this.reviewerList.filter(reviewerItem => evt.find(evtItem => evtItem.id !== this.DO_NOT_SEND_EMAIL_OPTION_ID && evtItem.id !== this.ALL_OPTION_ID && evtItem.id === reviewerItem.id)).map(so => so.id);
      this.selectedReviewers = selectedOptions;
    }
  }

  onSwitch() {
    if (!this.needToReview) {
      this.selectedReviewers = [] ;
    }
    this.changeReviewerEvent.emit({
      addForReview: this.needToReview,
      selectedReviewers: this.selectedReviewers,
      needToSendMPEvent: false
    });
    if (this.reviewerListComp) {
      this.reviewerListComp.ngSelect.isOpen = this.needToReview;
      this.reviewerListComp.ngSelect.isFocused = this.needToReview;
    }
  }

  eventDataForSegment() {
    return {
      action: UserActionType.ACTION,
      item: Page.INFLUENCER_GROUP,
      target: {
        type: TargetType.REQUEST_REVIEW
      },
      params: {
        action: UserActionType.TOGGLE,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        source: ActionSource.ACTION_VIEW,
      }
    };
  }

  get placeholder() {
    if (!this.selectedReviewers || !this.reviewerList) {
      return null;
    }
    if (this.selectedReviewers.length === 0) {
      return this.translate.instant('request_review.action_bar.no_selection');
    }
    if (this.selectedReviewers.length === 1) {
      const selectedReviewer = this.reviewerList.find(r => r.id === this.selectedReviewers[0]);
      return selectedReviewer ? selectedReviewer.name : null;
    }
    if (this.selectedReviewers.length > 0) {
      return this.translate.instant('request_review.action_bar.more_than_one_selection', {
        numOfSelection: this.selectedReviewers.length
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/send-to-review/send-to-review.component.ts